import {
  Button,
  ButtonOwnProps,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";

const EmailRequestView = (props: any) => {
  const { onClose, selectedValue, open, type, name, onSubmit, detail } = props;

  const [reason, setReason] = useState<string>("");
  const handleClose = () => onClose(selectedValue);

  return (
    <Dialog fullWidth onClose={handleClose} open={open}>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <DialogTitle>
          Request: <b>{type}</b>
        </DialogTitle>

        <DialogTitle>
          <Chip color="primary" label={name} />
        </DialogTitle>
      </Stack>

      <Divider />

      {detail && detail}

      <DialogContent>
        <DialogContentText>
          To submit a request, please enter a reason below. An administrator
          will contact you regarding your request status.
        </DialogContentText>

        <TextField
          autoFocus
          margin="dense"
          id="reason"
          label="Reason"
          type="reason"
          fullWidth
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          variant="standard"
        />
      </DialogContent>

      <DialogActions sx={{ m: 2 }}>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>

        <Button
          type="submit"
          variant="contained"
          disabled={!reason}
          onClick={() => {
            onSubmit(reason);
            handleClose();
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const EmailRequestDialog = ({
  type,
  name,
  detail,
  size = "medium",
  disabled = false,
  fullWidth = false,
  onSubmit,
}: {
  type: string;
  name: string;
  detail?: any;
  size?: ButtonOwnProps["size"];
  disabled?: boolean;
  fullWidth?: boolean;
  onSubmit: (reason: string) => void;
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button
        type="submit"
        size={size}
        color="secondary"
        variant="contained"
        onClick={handleOpen}
        disabled={disabled}
        fullWidth={fullWidth}
      >
        Request
      </Button>

      <EmailRequestView
        open={open}
        name={name}
        type={type}
        detail={detail}
        onClose={handleClose}
        onSubmit={onSubmit}
      />
    </div>
  );
};

export default EmailRequestDialog;
